import { apiService } from './index';
import { IRegisterUser } from '../shared/types/auth';
import { UserFilter } from '../shared/types/user';

export const asyncPostUser = async (formUser: IRegisterUser) => {
    return await apiService.post('/api/users', formUser);
};

export const asyncGetUsers = async (
    filters?: UserFilter,
    page?: number,
    pageSize?: number
) => {
    return await apiService.get('/api/users', {
        limit: pageSize || 20,
        page: page || 0,
        ...filters,
    });
};

export const asyncDeleteUser = async (id: string) => {
    return await apiService.delete(`/api/users/${id}`);
};

export const asyncReactivateUser = async (id: string) => {
    return await apiService.patch(`/api/users/reactivate/${id}`);
};

export const asyncGetUser = async (id: string | undefined) => {
    return await apiService.get(`/api/users/${id}`);
};

export const asyncGetUserByEmail = async (email: string | undefined) => {
    return await apiService.get(`/api/users/email/${email}`);
};

export const asyncPatchtUserPassword = async (id: string, formUser: any) => {
    return await apiService.patch(`/api/users/password/${id}`, formUser);
};

export const asyncPatchtUser = async (id: string, formUser: any) => {
    return await apiService.patch(`/api/users/${id}`, formUser);
};

export const asyncValidatePassword = async (
    email: string | undefined,
    password: string | undefined
) => {
    return await apiService.get(
        `/api/users/validate-password/${email}/${password}`
    );
};
